export default __webpack_public_path__ + "static/media/share.2226a155.svg";